<template>
    <div class="adjustCenter">
        <div class="centerContent">
            <div class="svg_loader">
                <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 38 38">
                    <defs>
                        <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                            <stop stop-color="#fff" stop-opacity="0" offset="0%" />
                            <stop stop-color="#fff" stop-opacity=".631" offset="63.146%" />
                            <stop stop-color="#fff" offset="100%" />
                        </linearGradient>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)">
                            <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="0.9s"
                                    repeatCount="indefinite"
                                />
                            </path>
                            <circle fill="#fff" cx="36" cy="18" r="1">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="0.9s"
                                    repeatCount="indefinite"
                                />
                            </circle>
                        </g>
                    </g>
                </svg>
                <h2>Logging in...</h2>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.$store
            .dispatch('login')
            .then(result => {
                console.log(this.$store.getters.prevUrl)
                if (this.$store.getters.prevUrl != undefined) {
                    this.$router.push(this.$store.getters.prevUrl)
                } else {
                    this.$router.push({ name: 'dashboard' })
                }
            })
            .catch(err => {
                this.$swal({
                    title: 'Login failed!',
                    text: 'Could not log you in, please verify that you have used the correct Discord account.',
                    icon: 'error',
                })
                //history.go(-2)
            })
    },
}
</script>

<style>
.svg_loader {
    display: block;
    text-align: center;
}
.svg_loader h2 {
    padding-top: 20px;
}
.adjustCenter {
    height: 100vh;
    width: 100%;
}
.centerContent {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/landing/callback.vue